import React, { useEffect, useState } from "react";
import { Box, Button, CircularProgress, Grid, Typography } from "@mui/material";
import GenericTable from "../../../components/table";
import { InvoiceApi } from "../../../apis";
import { useNavigate } from "react-router-dom";

const columns = [
  { field: "id", headerName: "Invoice #", sortable: true },
  { field: "projectName", headerName: "Project", sortable: true },
  { field: "clientName", headerName: "Client", sortable: true },
  { field: "invoiceDate", headerName: "Date", sortable: true },
  {
    field: "totalAmount",
    headerName: "Total Amount",
    sortable: true,
  },
];

function Invoices() {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const fetchInvoices = async () => {
    try {
      const res = await InvoiceApi.getAllInvoices();
      const data = res?.data?.data || res?.data || [];
      const list = Array.isArray(data) ? data : data.invoices || [];

      const mapped = list.map((inv) => ({
        id: inv.id,
        projectName: inv.project?.name || "",
        clientName: inv.project?.client?.clientNickname || inv.project?.client?.company || "",
        invoiceDate: inv.invoiceDate
          ? new Date(inv.invoiceDate).toLocaleDateString()
          : "",
        totalAmount: inv.totalAmount,
      }));

      setInvoices(mapped);
    } catch (error) {
      console.error("Error fetching invoices:", error);
      setInvoices([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInvoices();
  }, []);

  return (
    <Box>
      <Grid container spacing={2} mt={2} mb={4}>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <Typography variant="h4" fontWeight={600}>
            Invoices
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={6}
          xl={6}
          display="flex"
          justifyContent="flex-end"
        >
          <Button
            variant="contained"
            color="primary"
            onClick={() => navigate("/admin/invoices/add")}
          >
            Add Invoice
          </Button>
        </Grid>
      </Grid>

      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "300px",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <GenericTable
          data={invoices}
          columns={columns}
          showAction={true}
          isSearchShown={true}
          inlineEdit={false}
          onEdit={(row) => {
            navigate(`/admin/invoices/${row.id}/edit`);
          }}
          onDelete={async (id) => {
            // Optional: Add delete functionality if needed
            console.log("Delete invoice:", id);
          }}
        />
      )}
    </Box>
  );
}

export default Invoices;


